import * as yup from 'yup';
import {
  addOptionalToSchema,
  optionalNameSchema,
  phoneSchema,
  requiredErrorMessage,
  requiredNameSchema,
  stateSchema,
  zipSchema,
} from '@common/schema';

export const createBuildingSchema = yup.object().shape({
  name: requiredNameSchema,
  organization_id: yup.string(),
  partner_id: yup.string().required(requiredErrorMessage),
  operator_id: yup.string().required(requiredErrorMessage),
  google_places_id: yup.string().required(requiredErrorMessage),

  street: requiredNameSchema,
  suite: optionalNameSchema,
  city: requiredNameSchema,
  state: stateSchema.required(requiredErrorMessage),
  zip_code: zipSchema.required(),
  county: optionalNameSchema,
  phone_number: addOptionalToSchema(phoneSchema),
  fax_number: addOptionalToSchema(phoneSchema),
});
